// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14.5\" height=\"82.5\" viewBox=\"0 0 14.5 82.5\"> <path data-name=\"Path 7\" d=\"M14,0H4A4,4,0,0,0,0,4V82\" transform=\"translate(0.5 0.5)\" fill=\"none\" stroke=\"#ed0206\" stroke-miterlimit=\"10\" stroke-width=\"1\"/> </svg> ";
// Exports
module.exports = code;